import { gql } from '@apollo/client';

const NEW_RESOURCE_FRAGMENT = gql`
  fragment NewResource on Resource {
    id
    name
    parentId
    workspaceId
    type
    mimeType
  }
`;

export default NEW_RESOURCE_FRAGMENT;
